/* eslint-disable max-len */
import { INTL_IDS } from '../Main/messages';

export const ASSISTANCE_ERROR_MESSAGE = 'For assistance, please contact Customer Service.';

export const FORGOT_USERNAME_PASSWORD_ALLOWED_VIEWS = ['init', 'verify'];

export const REASON_CODE_DICTIONARY = {
  '3002.2000': { key: 'serviceError' },
  3002.2001: { key: 'password', message: 'New password is required' },
  3002.2002: { key: 'serviceError' },
  3002.2003: { key: 'password', message: 'New password has already been used' },
  3002.2004: { key: 'password', message: 'New password must be at least 10 characters long and must contain at least 1 lower case, 1 upper case, and 1 number' },
  3002.2006: { key: 'username', message: 'Username is required' },
  3002.2007: { key: 'bannerError', message: 'There\'s an issue with the recovery email you received. Please try resetting your password again.' },
  3002.2008: { key: 'serviceError' },
  3002.2009: { key: 'noError' },
  '3002.2010': { key: 'serviceError' },
  3002.2011: { key: 'bannerError', message: 'User account is locked' },
  3002.2012: { key: 'bannerError', message: 'Email link has expired' },
  3005.2001: { key: 'bannerError', message: 'User account is locked' },
  3005.2002: { key: 'serviceError' },
  3005.2003: { key: 'serviceError' },
  3005.2004: { key: 'serviceError' },
  3005.2005: { key: 'bannerError', message: 'Email link has expired' },
  3005.2006: { key: 'noError' },
  3005.2007: { key: 'email', message: 'Email is required' },
  3005.2009: { key: 'loanNumber', message: INTL_IDS.REGISTER_ERROR_LOAN_NUMBER_INVALID },
  3005.2014: { key: 'email', message: 'Email is not valid' },
  3005.2015: { key: 'bannerError', message: 'New email is the same as the old email' },
  3005.2016: { key: 'bannerError', message: 'Email is already in use' },
  3005.2017: { key: 'serviceError' },
  3005.2018: { key: 'bannerError', message: INTL_IDS.REGISTER_ERROR_LOAN_NOT_FOUND_OR_INVALID },
  3006.2001: { key: 'loanNumber', message: INTL_IDS.REGISTER_ERROR_LOAN_NUMBER_REQUIRED },
  3006.2002: { key: 'loanNumber', message: INTL_IDS.REGISTER_ERROR_LOAN_NUMBER_INVALID },
  3006.2003: { key: 'ssnTin', message: 'SSN/TIN is required' },
  3006.2004: { key: 'zipCode', message: 'Zip code is required' },
  3006.2005: { key: 'serviceError' },
  3006.2006: { key: 'username', message: 'Username is required' },
  3006.2007: { key: 'password', message: 'Password is required' },
  3006.2008: { key: 'email', message: 'Email is required' },
  3006.2009: { key: 'serviceError' },
  '3006.2010': { key: 'bannerError', message: INTL_IDS.REGISTER_ERROR_LOAN_NOT_ELIGIBLE },
  3006.2011: { key: 'bannerError', message: INTL_IDS.REGISTER_ERROR_LOAN_ALREADY_REGISTERED },
  3006.2012: {
    key: 'bannerError',
    message: `Please confirm the entered information is correct. ${ASSISTANCE_ERROR_MESSAGE}`,
  },
  3006.2013: { key: 'email', message: 'Email is not valid' },
  3006.2014: { key: 'serviceError' },
  3006.2015: {
    key: 'password',
    message: `Password must be at least 10 characters long and must contain at least 1 lower case,
    1 upper case and 1 number`,
  },
  3006.2016: { key: 'serviceError' },
  3006.2018: { key: 'username', message: 'Username is already in use' },
  3006.2019: { key: 'password', message: 'Password is required' },
  '3006.2020': { key: 'bannerError', message: 'The username or password is incorrect.' },
  3006.2021: { key: 'bannerError', message: 'The username or password is incorrect.' },
  3006.2022: { key: 'bannerError', message: `Registration is already complete. ${ASSISTANCE_ERROR_MESSAGE}` },
  3006.2023: { key: 'bannerError', message: INTL_IDS.REGISTER_ERROR_RETRIEVE_LOAN_INFO },
  3006.2024: { key: 'bannerError', message: INTL_IDS.REGISTER_ERROR_RETRIEVE_LOAN_INFO },
  3006.2027: {
    key: 'username',
    message: 'Username can only contain letters and numbers and must be at least 5 characters long',
  },
  3006.2028: { key: 'ssoLoanError' },
};
